<template lang="pug">
extends ../../../prototype/src/pug/layout/section_column
include ../../../prototype/src/pug/abstracts/mixin.pug
block main
	include ../../../prototype/src/pug/abstracts/variables
	.modelo_escolhido__wrapper
		h1.modelo_escolhido__text_block('v-html'="detail.title") xxx

		p.modelo_escolhido__text('v-html'="detail.description") xxx

		h2.modelo_escolhido__section--title Para que serve?
		.modelo_escolhido__text('v-html'="detail.serventia")
			| xxx

		h2.modelo_escolhido__section--title Modelos
		.modelo_escolhido__text 
			.modelo_escolhido__feature
				+i('monitor.svg')
				p
					strong A1
					| – Arquivo para instalação no computador com validade de 1 ano. (Não funciona em tablet ou smartphone)

			.modelo_escolhido__feature
				+i('credit-card-1.svg')
				p
					strong Cartão
					| - Validade de 1, 2 ,3 e 5 anos. (É preciso possuir um leitor de cartão para utilização do Certificado)

			.modelo_escolhido__feature
				+i('flash-drive.svg')
				p
					strong Token
					| - Mídia criptográfica com conexão USB, tem validade de 1, 2, 3 e 5 anos.
					
			.modelo_escolhido__feature
				+i('icon_card_oab-02_1.svg')
				p
					strong e-Jurídico
					| - É a identidade digital usada exclusivamente por advogados inscritos na OAB. Permite gerar assinaturas digitais com validade jurídica para documentos e transações no ambiente digital.

			.modelo_escolhido__feature
				+i('cloud.svg')
				p
					strong SPC Safe ID
					| - O SPC Safe ID SPC Brasil é seu Certificado Digital armazenado na nuvem. Além de ser tão seguro quanto os demais Certificados Digitais, o SPC Safe ID dispensa a necessidade do uso de mídias criptográficas e é gerenciável, permitindo, entre outros diferenciais, sua utilização em múltiplos computadores, possui validade de 01 e 04 anos.
			
			.modelo_escolhido__feature
				+i('cloud.svg')
				p
					strong e-Saúde
					| - É a identidade digital de profissionais da saúde que buscam mais segurança e agilidade no dia a dia.

		.modelo_escolhido__appliances(@click = "toggle" v-bind:class="{ 'expand' : isShowFeatures }" 'v-if'="detail.options")
			.modelo_escolhido__appliances--title 
				|Aplicações para cada tipo de Certificado:

			.modelo_escolhido__appliances__table
				table
					ComprarRow('v-for'="row in detail.options", :row="row")


		PrecisaDeAjudaTag

		BannerComprarAgora(:url="detail.url")

</template>

<script>
import data from "@/assets/aplicacoes.json";
import BannerComprarAgora from "@/components/BannerComprarAgora.vue";
import ComprarRow from "@/components/comprar/comprar_row.vue";
import PrecisaDeAjudaTag from "@/components/PrecisaDeAjudaTag.vue";

export default {
	name: "ComprarDetalhe",
	components: {
		ComprarRow,
		PrecisaDeAjudaTag,
		BannerComprarAgora,
	},
	data: function () {
		return {
			isShowFeatures: false,
		};
	},
	computed: {
		id: function () {
			return this.$route.params.type;
		},
		detail: function () {
			for (var i = 0; i < data.length; i++) {
				if (data[i].id == this.id) {
					return data[i];
				}
			}
			return null;
		},
	},
	methods: {
		toggle: function () {
			console.log("toggle");
			this.isShowFeatures = !this.isShowFeatures;
		},
	},
};
</script>
